<!-- -->
<template>
  <div :class="{ frame: true, 'm-frame': isMobile }">
    <div class="banner">
      <img :src="URL + '/static/banner_join.jpg'" alt="" />
      <div class="type">加入我们</div>
    </div>
    <div class="box">
      <div class="title-box">
        <div class="title">招贤纳士</div>
      </div>
      <div class="content" v-if="jobList.length > 0">
        <div
          class="item"
          v-for="item in jobList"
          :key="item.id"
          @click="changeExpand(item)"
        >
          <div class="head">
            <div class="title">{{ item.jobName }}</div>
            <img
              src="@/assets/expand.png"
              alt=""
              :class="{ expand: true, active: item.expand }"
            />
          </div>
          <div
            class="detail rich"
            v-html="item.dutyContent"
            v-show="item.expand"
          ></div>
        </div>
      </div>
      <el-empty description="暂无招聘信息" v-else></el-empty>
    </div>
    <div class="support">
      <div class="title-box">
        <div class="title" style="color: #fff">我们所提供的</div>
      </div>
      <div class="list">
        <div class="item">有竞争力的薪酬</div>
        <div class="item">完善的福利体系</div>
        <div class="item">舒适的工作环境</div>
        <div class="item">成熟的晋升体系</div>
        <div class="item">灵活的考勤方式</div>
        <div class="item">热情的团队氛围</div>
      </div>
      <div class="card">
        <div class="main">
          应聘简历请发送邮箱至：{{ globalConfig.jobEmail }}<br />
          请在邮件标题中注明应聘的职位名称<br />
          可以添加我们HR微信，期待您的加入
        </div>
        <div class="code">
          <img :src="URL + globalConfig.hrWeixinUrl" alt="" class="url" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import { URL } from "@/util/config";

export default {
  data() {
    return {
      URL,
      jobList: [],
    };
  },
  computed: {
    ...mapState(Store, ["globalConfig", "isMobile"]),
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      let res = await this.$api.getJob();
      this.jobList = res.data.map((ele) => {
        ele.expand = false;
        return ele;
      });
    },
    changeExpand(item) {
      item.expand = !item.expand;
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  position: relative;

  img {
    width: 100%;
  }
  .type {
    width: 100%;
    text-align: center;
    font-size: 48px;
    color: #fff;
    position: absolute;
    left: 0;
    bottom: 150px;
  }
}
.title-box {
  text-align: center;
  position: relative;
  z-index: 2;

  .title {
    font-size: 40px;
    color: $theme;
    font-weight: bold;
  }
}
.box {
  padding: 60px 0 40px;

  .content {
    width: 1200px;
    margin: 60px auto 80px;

    .item {
      box-shadow: 5px 4px 14px rgba(0, 82, 217, 0.08);
      color: #212121;

      & + .item {
        margin-top: 30px;
      }
      .head {
        height: 80px;
        padding: 0 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        .title {
          font-size: 27px;
          font-weight: bold;
        }
        .expand {
          width: 20px;
          transform: rotate(180deg);
          transition: 0.5s;
        }
        .active {
          transform: rotate(0);
        }
      }
      .detail {
        padding: 30px 50px;
        line-height: 36px;
        white-space: pre-wrap;
      }
    }
  }
}

.support {
  padding: 100px 0 50px;
  box-sizing: border-box;
  background-image: url("http://gxbg.pangodso.com/file/static/support_bg.jpg");
  background-size: 1925px 540px;
  background-position-x: center;
  background-repeat: no-repeat;
}
.list {
  width: 750px;
  margin: 80px auto 60px;
  display: flex;
  flex-wrap: wrap;
  color: #fff;
  font-size: 19px;

  .item {
    width: 33%;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
  }
  .item::before {
    content: "";
    display: block;
    width: 5px;
    height: 5px;
    margin-right: 9px;
    background-color: #fff;
    border-radius: 50%;
  }
}
.card {
  width: 1200px;
  margin: 0 auto;
  padding: 30px 0;
  background-color: #fff;
  box-shadow: 5px 4px 14px rgba(0, 82, 217, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-around;

  .main {
    font-size: 20px;
    line-height: 37px;
    color: #212121;
  }
  .code {
    position: relative;

    .url {
      width: 223px;
    }
    .tip {
      color: #414141;
      letter-spacing: 10px;
      writing-mode: vertical-rl;
      position: absolute;
      right: -25px;
      bottom: 0;
    }
  }
}

.m-frame {
  .banner {
    height: 165px;

    img {
      height: 100%;
      object-fit: cover;
    }
    .type {
      bottom: 20%;
      font-size: 20px;
    }
  }
  .box {
    padding: 20px 0;
  }
  .title-box .title {
    font-size: 25px;
  }
  .content {
    width: 100%;
    margin: 20px 0;
    padding: 0 10px;
    box-sizing: border-box;

    .item {
      .head {
        height: 50px;
        padding: 0 20px;

        .title {
          font-size: 20px;
        }
        .expand {
          width: 14px;
        }
      }
      .detail {
        padding: 10px 20px;
      }
    }
  }
  .support {
    .list {
      width: 100%;
      padding: 0 20px;
      box-sizing: border-box;
      justify-content: center;

      .item {
        width: 50%;
        font-size: 14px;
        justify-content: center;
      }
    }
    .card {
      width: 100%;
      flex-direction: column;

      .main {
        font-size: 16px;
        line-height: 1.8;
      }
      .code {
        margin-top: 10px;
      }
    }
  }
}
</style>
